// v2.22.2: the upload queue kept in this browser (IndexedDB), so after the browser was closed the app can offer
// "Lanjutkan unggahan". Only names, sizes, hashes and — in Chrome/Edge — file/folder handles are stored, never
// file contents. Every call fails quietly (private window, blocked storage): the queue then simply is not kept.
const NAMA_DB = "soqprint-unggah";
const TOKO = "antrean";

function buka() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") { reject(new Error("IndexedDB tidak tersedia")); return; }
    const r = indexedDB.open(NAMA_DB, 1);
    r.onupgradeneeded = () => { if (!r.result.objectStoreNames.contains(TOKO)) r.result.createObjectStore(TOKO, { keyPath: "id" }); };
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  });
}

async function kerja(mode, fn) {
  const db = await buka();
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction(TOKO, mode);
      const hasil = fn(tx.objectStore(TOKO));
      tx.oncomplete = () => resolve(hasil?.result);
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(tx.error);
    });
  } finally { db.close(); }
}

export const simpanUnggah = {
  async semua() { try { return (await kerja("readonly", (s) => s.getAll())) || []; } catch { return []; } },
  async taruh(rec) {
    try { await kerja("readwrite", (s) => s.put(rec)); } catch {
      // a handle that cannot be stored (older browser): keep the rest
      try { await kerja("readwrite", (s) => s.put({ ...rec, handle: null, akar: null })); } catch { /* not kept */ }
    }
  },
  async hapus(id) { try { await kerja("readwrite", (s) => s.delete(id)); } catch { /* not kept */ } },
};
